import React from 'react';

import DeskNav from '../layouts/DeskNav';
import Job from './Job';

import '../../styles/employment.scss'; 

export default (props) => {
	return(
		<main className='employment'>
			<DeskNav />
			<section>
				<h2> {props.employment.title} </h2>
				{
					props.employment.jobs.map((elem,index) => <Job key={`job-${index}`} job={elem} />)

				}
			</section>
		</main>
	);
}